export default {
  "Choose File": "Choose File",
  "Please paste a URL": "Please paste a URL",
  Loading: "Loading",
  Analyzing: "Analyzing",
  "Try a sample": "Try a sample",
  "Sorry, error occurs when analyzing the URL.": "Sorry, an error occurs when analyzing the URL.",
};
